/* Fidget Critter redesign: holiday season engine (client-side, visitor's local date).
   Drives: hero seasonal bubble, header menu highlight, homepage holiday banner, landing-page countdowns.
   Moveable dates (Easter, Mother's Day, Father's Day) come from Theme settings > "Holiday dates"
   (window.FC_SEASON_DATES, set in layout/theme.liquid); when blank or out of date they are computed.
   Preview any date with ?fc_date=YYYY-MM-DD in the URL. */
(function () {
  'use strict';
  var MS = 86400000;
  var CFG = window.FC_SEASON_DATES || {};
  function day(y, m, d) { return new Date(y, m, d); }
  function add(d, n) { return new Date(d.getFullYear(), d.getMonth(), d.getDate() + n); }
  function parse(s) {
    var m = /^\s*(\d{4})-(\d{1,2})-(\d{1,2})\s*$/.exec(s || '');
    return m ? day(+m[1], +m[2] - 1, +m[3]) : null;
  }
  function today() {
    var q = /[?&]fc_date=(\d{4}-\d{1,2}-\d{1,2})/.exec(location.search);
    var t = q && parse(q[1]);
    if (t) return t;
    try { /* store calendar day in America/Denver, whatever the visitor's own time zone is */
      var ps = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Denver', year: 'numeric', month: 'numeric', day: 'numeric' }).formatToParts(new Date()), o = {};
      for (var i = 0; i < ps.length; i++) o[ps[i].type] = ps[i].value;
      if (o.year && o.month && o.day) return day(+o.year, +o.month - 1, +o.day);
    } catch (e) {}
    var n = new Date();
    return day(n.getFullYear(), n.getMonth(), n.getDate());
  }
  function easter(y) { /* anonymous Gregorian algorithm */
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4,
        f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30,
        i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7,
        m = Math.floor((a + 11 * h + 22 * l) / 451), mo = Math.floor((h + l - 7 * m + 114) / 31),
        da = ((h + l - 7 * m + 114) % 31) + 1;
    return day(y, mo - 1, da);
  }
  function nthSunday(y, month, n) {
    var first = day(y, month, 1);
    return day(y, month, 1 + ((7 - first.getDay()) % 7) + 7 * (n - 1));
  }
  function setting(key, y, fallback) {
    var d = parse(CFG[key]);
    return d && d.getFullYear() === y ? d : fallback(y);
  }
  function monthBefore(h) { return day(h.getFullYear(), h.getMonth() - 1, h.getDate()); }

  /* Shipping line DATE SWITCH (Oct 20 2026, owner): cut = order-by cutoff in days before the holiday (America/Denver calendar day).
     Up to and including the cutoff: "Order by <Month D> for the best chance at <name> delivery." (bubble "Order by <Mon D>").
     Day after the cutoff through the holiday: "Not guaranteed to deliver by <by>." (bubble "Not guaranteed by <by>").
     Christmas keeps "Ships by December 11." + live countdown up to the cutoff. ship / shipShort below are only the static early fallbacks.; Christmas keeps the Dec 11 countdown).
     shipBy (Christmas) = live countdown target, ISO with offset. ob is kept only for the old hero countdown.
     ob = order-by offset (days before holiday); bubble = hero bubble + menu highlight start;
     banner = homepage banner start. Bubble/menu end the day after the holiday; banner ends on the holiday. */
  var H = [
    { k: 'christmas', name: 'Christmas', icon: '\uD83C\uDF84', date: function (y) { return day(y, 11, 25); }, ob: 24, cut: 14,
      ship: 'Ships by December 11.', shipShort: 'Ships by Dec 11', shipBy: function (y) { return y + '-12-11T23:59:59-07:00'; },
      bubble: function (h) { return day(h.getFullYear(), 10, 15); }, banner: monthBefore },
    { k: 'valentines', name: "Valentine's Day", short: "Valentine's", icon: '\uD83D\uDC98', date: function (y) { return day(y, 1, 14); }, ob: 21, cut: 14,
      ship: "Order by January 31 for the best chance at Valentine's Day delivery.", shipShort: 'Order by Jan 31',
      bubble: function (h) { return add(h, -28); }, banner: monthBefore },
    { k: 'easter', name: 'Easter', icon: '\uD83D\uDC23', date: function (y) { return setting('easter', y, easter); }, ob: 21, cut: 14,
      ship: 'Order by March 14 for the best chance at Easter delivery.', shipShort: 'Order by Mar 14',
      bubble: function (h) { return add(h, -27); }, banner: monthBefore },
    { k: 'mothers-day', name: "Mother's Day", icon: '\uD83D\uDC90', date: function (y) { return setting('mothers_day', y, function (yy) { return nthSunday(yy, 4, 2); }); }, ob: 21, cut: 14,
      ship: "Order by April 25 for the best chance at Mother's Day delivery.", shipShort: 'Order by Apr 25',
      bubble: function (h) { return add(h, -28); }, banner: monthBefore },
    { k: 'fathers-day', name: "Father's Day", icon: '\uD83D\uDC54', date: function (y) { return setting('fathers_day', y, function (yy) { return nthSunday(yy, 5, 3); }); }, ob: 21, cut: 14,
      ship: "Order by June 6 for the best chance at Father's Day delivery.", shipShort: 'Order by Jun 6',
      bubble: function (h) { return add(h, -28); }, banner: monthBefore },
    { k: 'fourth-of-july', name: 'Fourth of July', short: '4th of July', icon: '\uD83C\uDF86', date: function (y) { return day(y, 6, 4); }, ob: 21, cut: 14, by: 'the Fourth of July',
      ship: 'Order by June 20 for the best chance at Fourth of July delivery.', shipShort: 'Order by Jun 20',
      bubble: function (h) { return add(h, -28); }, banner: monthBefore },
    { k: 'halloween', name: 'Halloween', icon: '\uD83C\uDF83', date: function (y) { return day(y, 9, 31); }, ob: 7, cut: 10,
      ship: 'Order by October 21 for the best chance at Halloween delivery.', shipShort: 'Order by Oct 21',
      bubble: function (h) { return day(h.getFullYear(), 9, 1); }, banner: function (h) { return day(h.getFullYear(), 9, 1); } }
  ];
  var byKey = {};
  /* Christmas landing page was removed (Oct 2026): Christmas links go to the collection instead. */
  H.forEach(function (h) { h.url = h.k === 'christmas' ? '/collections/christmas' : '/pages/' + h.k; byKey[h.k] = h; });

  function cycle(h, y) {
    var hd = h.date(y);
    return { holiday: hd, orderBy: add(hd, -h.ob), bubbleStart: h.bubble(hd), bubbleEnd: add(hd, 1), bannerStart: h.banner(hd), bannerEnd: hd };
  }
  function active(kind, t) {
    t = t || today();
    var out = [];
    H.forEach(function (h) {
      for (var y = t.getFullYear() - 1; y <= t.getFullYear() + 1; y++) {
        var c = cycle(h, y);
        if (t >= c[kind + 'Start'] && t <= c[kind + 'End']) { out.push({ h: h, c: c }); break; }
      }
    });
    out.sort(function (a, b) { return a.c.holiday - b.c.holiday; });
    return out;
  }
  function next(h, t) { /* the upcoming holiday (today counts); rolls to next year once it passes */
    t = t || today();
    var c = cycle(h, t.getFullYear());
    if (c.holiday < t) c = cycle(h, t.getFullYear() + 1);
    return c;
  }
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var MONTH = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var DOW = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  function shortDate(d) { return MON[d.getMonth()] + ' ' + d.getDate(); }
  function longDate(d) { return DOW[d.getDay()] + ', ' + MONTH[d.getMonth()] + ' ' + d.getDate(); }
  function daysBetween(a, b) { return Math.round((b - a) / MS); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  var EXPIRED = 'Ships within 5 business days.';
  function cutoff(h, c) { return add(c.holiday, -(h.cut || 14)); }
  function isLate(h, t) { var c = next(h, t); return t > cutoff(h, c); }
  function lateText(h) { return 'Not guaranteed to deliver by ' + (h.by || h.name) + '.'; }
  function fullText(h, t) { /* long line for banners, hero fine print and product pages */
    var c = next(h, t), co = cutoff(h, c);
    if (t > co) return lateText(h);
    if (h.k === 'christmas') return h.ship;
    return 'Order by ' + MONTH[co.getMonth()] + ' ' + co.getDate() + ' for the best chance at ' + h.name + ' delivery.';
  }
  function shortText(h, t) { /* hero bubbles */
    var c = next(h, t), co = cutoff(h, c);
    if (t > co) return 'Not guaranteed by ' + (h.by || h.name);
    if (h.k === 'christmas') return h.shipShort;
    return 'Order by ' + MON[co.getMonth()] + ' ' + co.getDate();
  }
  function left(ms) { var m = Math.floor(ms / 60000), d = Math.floor(m / 1440), h = Math.floor((m % 1440) / 60), mm = m % 60;
    return (d ? d + 'd ' : '') + h + 'h ' + mm + 'm left'; }
  function shipText(h, c, custom, target, t) { /* custom/target come from the banner block settings when filled in */
    t = t || today();
    if (isLate(h, t)) return lateText(h);
    var tgt = target || (h.shipBy ? h.shipBy(c.holiday.getFullYear()) : '');
    var base = custom || fullText(h, t);
    if (!tgt) return base;
    var ms = Date.parse(tgt) - Date.now();
    if (isNaN(ms) || ms <= 0) return base;
    return base.replace(/\.$/, '') + ' \u2014 ' + left(ms);
  }
  function renderShipLines(t) { /* server-rendered order-by lines (product pages, holiday hero) + Christmas ship-by countdowns */
    var els = document.querySelectorAll('[data-fc-ship-line]');
    for (var i = 0; i < els.length; i++) {
      var h = byKey[els[i].getAttribute('data-fc-ship-line')];
      if (h) els[i].textContent = fullText(h, t);
    }
    var cds = document.querySelectorAll('[data-fc-ship-holiday]');
    for (var j = 0; j < cds.length; j++) {
      var el = cds[j], hk = byKey[el.getAttribute('data-fc-ship-holiday')];
      if (!hk || !isLate(hk, t)) continue;
      if (el.hasAttribute('data-fc-ship-cd')) { el.setAttribute('data-fc-ship-cd-off', el.getAttribute('data-fc-ship-cd')); el.removeAttribute('data-fc-ship-cd'); }
      var lab = el.querySelector('[data-fc-ship-label]'), tm = el.querySelector('[data-fc-ship-left]');
      if (lab) lab.textContent = lateText(hk);
      if (tm) { tm.textContent = ''; tm.hidden = true; }
      el.classList.add('is-passed');
    }
  }
  function renderCountdowns(t) {
    var els = document.querySelectorAll('[data-fc-countdown]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i], h = byKey[el.getAttribute('data-fc-countdown')];
      if (!h) continue;
      var c = next(h, t), html;
      html = '<span class="fc-cd__num">' + h.icon + '</span><span class="fc-cd__txt"><strong>' + esc(shipText(h, c, '', '', t)) + '</strong></span>';
      el.innerHTML = html;
      el.hidden = false;
    }
  }
  function renderBubbles(t) {
    var list = active('bubble', t);
    var hosts = document.querySelectorAll('.fc-bubbles:not(.fc-hd__bubbles)');
    for (var i = 0; i < hosts.length; i++) {
      var host = hosts[i], head = host.querySelector('.fc-bubbles__head');
      if (!head || host.querySelector('.fc-season-bubble')) continue;
      var wrap = document.createElement('span');
      wrap.className = 'fc-season-bubbles';
      list.forEach(function (a) {
        var b = document.createElement('a');
        b.className = 'fc-season-bubble fc-season--' + a.h.k;
        b.href = a.h.url;
        b.innerHTML = '<span class="fc-season-bubble__icon" aria-hidden="true">' + a.h.icon + '</span><span class="fc-season-bubble__title">' +
          esc(a.h.short || a.h.name) + '</span><span class="fc-season-bubble__deal">' + esc(shortText(a.h, t)) + '</span>';
        wrap.appendChild(b);
      });
      if (list.length) head.insertAdjacentElement('afterend', wrap);
    }
  }
  function renderMenu(t) {
    var list = active('bubble', t);
    if (!list.length) return;
    var root = document.querySelector('header-component, .header-section, #header-group, header') || document;
    var scopes = [root];
    var drawer = document.querySelector('header-drawer, .menu-drawer');
    if (drawer && scopes.indexOf(drawer) < 0) scopes.push(drawer);
    list.forEach(function (a) {
      scopes.forEach(function (s) {
        var links = s.querySelectorAll('a[href$="' + a.h.url + '"]');
        for (var i = 0; i < links.length; i++) {
          if (links[i].classList.contains('fc-menu-season')) continue;
          links[i].classList.add('fc-menu-season', 'fc-season--' + a.h.k);
          links[i].insertAdjacentHTML('beforeend', ' <span class="fc-menu-season__tag">' + a.h.icon + ' Now</span>');
        }
      });
    });
    /* flag on the top-level Shop item */
    var a0 = list[0];
    var tops = document.querySelectorAll('header .menu-list__link, header nav a, header nav summary, header nav button');
    for (var j = 0; j < tops.length; j++) {
      var el = tops[j];
      if (el.closest('.fc-menu-season, [class*="submenu"] [class*="submenu"]')) continue;
      var txt = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (/^Shop$/i.test(txt) && !el.querySelector('.fc-shop-flag')) {
        el.classList.add('fc-season--' + a0.h.k);
        (el.querySelector('span') || el).insertAdjacentHTML('beforeend', '<span class="fc-shop-flag" title="' + esc(a0.h.name) + ' shop is open" aria-hidden="true">' + a0.h.icon + '</span>');
      }
    }
  }
  function renderHomeBanner(t) {
    var hosts = document.querySelectorAll('[data-fc-home-banner]');
    var list = active('banner', t);
    for (var i = 0; i < hosts.length; i++) {
      var host = hosts[i], shown = false;
      if (host.hasAttribute('data-design-mode')) { host.hidden = false; continue; }
      var items = host.querySelectorAll('[data-fc-holiday]');
      for (var j = 0; j < items.length; j++) {
        var k = items[j].getAttribute('data-fc-holiday');
        var hit = !shown && list.some(function (a) { return a.h.k === k; });
        items[j].hidden = !hit;
        if (hit) {
          shown = true;
          var cd = items[j].querySelector('[data-fc-banner-orderby]');
          if (cd) {
            var it = items[j], c = next(byKey[k], t);
            cd.textContent = shipText(byKey[k], c, it.getAttribute('data-fc-ship-text'), it.getAttribute('data-fc-ship-target'), t);
          }
        }
      }
      host.hidden = !shown;
      var sec = host.closest('.shopify-section');
      if (sec) sec.classList.toggle('fc-hhb-empty', !shown);
    }
  }
  var tickOn = false;
  function run() {
    if (!tickOn) { tickOn = true; setInterval(function () { try { renderHomeBanner(today()); renderCountdowns(today()); renderShipLines(today()); } catch (e) {} }, 30000); }
    var t = today();
    try { renderCountdowns(t); } catch (e) {}
    try { renderShipLines(t); } catch (e) {}
    try { renderBubbles(t); } catch (e) {}
    try { renderMenu(t); } catch (e) {}
    try { renderHomeBanner(t); } catch (e) {}
  }
  window.FCSeasons = { holidays: H, active: active, next: next, today: today, run: run, fullText: fullText, shortText: shortText, isLate: isLate };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  /* the theme's header finishes building its menus after DOMContentLoaded, so re-apply the highlight */
  function menuAgain() { try { renderMenu(today()); } catch (e) {} }
  window.addEventListener('load', menuAgain);
  setTimeout(menuAgain, 1500); setTimeout(menuAgain, 4000);
  document.addEventListener('shopify:section:load', run);
})();
